import React, { useContext } from 'react';

import NavBarContext from '../../../contexts/NavBarContext';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { findCloudinaryImage } from '../../../utilities';
import Icon from '@components/utils/IconWrap';

import { CompanyContent } from './_Context';

export default function CompanyDock() {
  const { navBarImages } = useContext(NavBarContext);
  const { SubNavigation, Contacts } = CompanyContent;

  return (
    <div className="">
      <div className="bg-base-300">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid grid-cols-4 divide-x divide-base-100 border-x border-base-100">
            {SubNavigation.map(item => (
              <a
                key={item.name}
                href={item.href}
                className="flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-base-content hover:bg-base-200"
              >
                <Icon
                  icon={item.icon}
                  aria-hidden="true"
                  className="size-5 flex-none text-neutral"
                />
                {item.name}
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-row container mx-auto">
        {/* Left side of the dock */}
        <div name="image">
          <GatsbyImage
            className="rounded my-5 h-4/5"
            image={getImage(
              findCloudinaryImage({
                fileName: 'apcon-manufacturing-floor-1000w-515h',
                images: navBarImages,
              })
            )}
          />
        </div>

        {/* middle of the dock */}
        <div name="content" className="flex flex-col m-5 ">
          {/* Company Message */}
          <div
            name="companyMessage"
            className="border-b-2 border-base-200 pb-5"
          >
            <div name="preheader" className="text-neutral text-sm ">
              WHO IS APCON?
            </div>
            <div
              name="header"
              className="text-base-content text-2xl font-extrabold"
            >
              Securing Networks for over 30 years{' '}
            </div>
            <div name="paragraph" className="mt-1 text-neutral">
              APCON designs and assembles technologies in America that provide
              critical infrastructure for the world&apos;s largest and fastest
              on-premise, cloud, or hybrid networks. APCON products monitor,
              filter, and streamline data 24 x 7 x 365 to optimize traffic for
              maximum network performance.
            </div>
          </div>

          {/* Contact Info */}
          <div name="contatcInfos" className="flex flex-row">
            {Contacts.map(contact => (
              <div className="w-1/4 p-3" key={contact.name}>
                <div className="font-bold text-base-content">
                  {' '}
                  {contact.name}
                </div>
                <div className="text-neutral"> {contact.address}</div>
                <div className="text-neutral"> {contact.phone}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
